import 'css-chunksrc/client/scenes/costProfileCreation/form/costInput/styles.scss';export default {
  "costInput": "_costInput_nj5vi_1",
  "input": "_input_nj5vi_6",
  "placeholder": "_placeholder_nj5vi_10"
};